import { defineStore } from 'pinia';
import { USER_TYPES } from '@/common/utils';

const useSessionStore = defineStore('session', {
  state: () => {
    return {
      profileType: '',
      userId: '',
      children: [],
      childInfo: {},
      childSelectedId: '',
      userName: '',
      userLastName: '',
      parentName: '',
      themeSelection: '',
      isFirstTime: false,
      userEmail: '',
    };
  },
  actions: {
    setProfileType(type) {
      this.profileType = type;
    },
    setThemeSelection(selection) {
      this.themeSelection = selection;
    },
    setUserInfo(userInfo) {
      this.userName = userInfo.name;
      this.userLastName = userInfo.last_name;
      this.userEmail = userInfo.user.email;
    },
    setChildInfo(childInfo) {
      this.children = this.children.map((child) => {
        if (child.id === childInfo.id) {
          return {
            ...child,
            name: childInfo.name,
            lastName: childInfo.last_name,
            avatar: childInfo?.avatar?.image || child.avatar,
            childIsActive: childInfo.account_access,
          };
        }
        return child;
      });
    },
  },
  getters: {
    userIsAParent: (state) => state.profileType === USER_TYPES.PARENT,
    childName: (state) =>
      state.profileType === USER_TYPES.PARENT && state.childSelectedId !== ''
        ? state.children.find((children) => children.id == Number(state.childSelectedId))?.name
        : state.userName,
    getCurrentChild: (state) => {
      const isChildValid = state.childSelectedId !== '';
      const isParent = state.profileType === USER_TYPES.PARENT;
      if (!isChildValid || !isParent) return state.childInfo;

      const currentChild = state.children.find(
        (children) => children.id == Number(state.childSelectedId),
      );
      return currentChild;
    },
  },
});

export { useSessionStore };
